import { render } from "./formSelect.vue?vue&type=template&id=1bdcdaaa"
import script from "./formSelect.vue?vue&type=script&lang=js"
export * from "./formSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__